import React from 'react';
import BottomTabBar from './BottomTabBar';
import TopNavBar from '../common/TopNavBar';

const DashboardLayout = ({ children, showTopNav = true, showBottomNav = true }) => {
  return (
    <div
      className={`bg-background-light dark:bg-background-dark font-display text-slate-900 dark:text-white ${showBottomNav ? 'pb-[88px] md:pb-0' : ''}`}
      style={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      {showTopNav && <TopNavBar />}
      <main
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        {children}
      </main>

      {showBottomNav && <BottomTabBar />}
    </div>
  );
};

export default DashboardLayout;
